<script>
import cloneDeep from 'lodash/cloneDeep'
import {
  agentDetailsComputed,
  agentDetailsMethods,
} from '@state/helpers/agent-details'
import { STATUS_REQUEST, ROLE } from '@utils/constant'
import messageItems from './messageItems'

export default {
  props: {
    triggerMask: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      items: cloneDeep(messageItems),
      editable: false,
      ROLE: ROLE,
    }
  },
  computed: {
    ...agentDetailsComputed,
    itemsComputed() {
      if (this.getDetails) {
        const details = this.getDetails
        return this.items?.map((item) => {
          if (details[item.key]) {
            item.value = details[item.key]
          }
          return item
        })
      }
      return this.items
    },
    currentUserLevel() {
      const user = this.$store.getters['auth/getCurrentUser']
      return user?.level
    },
    errorServerSideComputed() {
      return this.getEditErrors
    },
  },
  watch: {
    // watch status request edit api
    getEditStatus() {
      // if edit success reset vuex state, toggle editable state and call api details
      if (this.getEditStatus === STATUS_REQUEST.SUCCESS) {
        this.editable = false
      }
    },
  },
  methods: {
    ...agentDetailsMethods,
    toggleEdiable() {
      this.items = this.itemsComputed
      this.editable = !this.editable
      this.$emit('enable:edit', this.editable)
    },
    updateMessageInfo() {
      const payload = this.items.reduce((results, item) => {
        results[item.key] = item.value
        return results
      }, {})
      this.updateAgent({ ...this.getDetails, ...payload })
    },
  },
}
</script>

<template>
  <div>
    <BaseCardDetail
      title="入会/退会メッセージ"
      :errors="errorServerSideComputed"
      form-collapsed
      :trigger-mask="!editable && triggerMask"
      :has-footer="editable"
      @edit="toggleEdiable"
      @cancel="toggleEdiable"
      @submit="updateMessageInfo"
    >
      <template v-slot:header-action="{ edit }">
        <CButton
          v-show="
            currentUserLevel === ROLE.SUPER ||
              currentUserLevel === ROLE.AGENT_ADMIN ||
              currentUserLevel === ROLE.AGENT_SUB
          "
          variant="ghost"
          @click="edit"
        >
          <CIcon name="cil-pencil" />
        </CButton>
      </template>
      <CRow
        v-for="item in itemsComputed"
        :key="item.key"
        class="d-flex align-items-baseline"
      >
        <CCol sm="4">
          {{ $t(`fields.${item.label}`) }}
          <span v-if="item.rules.required" class="text-danger">*</span>
        </CCol>
        <CCol v-if="currentUserLevel === ROLE.SUPER" sm="8">
          <BaseInput
            v-if="item.as === 'input'"
            v-show="item.key === 'privacy_policy_URL' && editable"
            v-model="item.value"
            :rules="editable && item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            :plaintext="!editable"
          />
          <BaseTextarea
            v-if="item.as === 'area'"
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            :plaintext="!editable"
          />
          <div class="form-group">
            <CLink
              v-show="item.key === 'privacy_policy_URL' && !editable"
              :href="item.value"
              target="_blank"
            >
              {{ item.value }}
            </CLink>
          </div>
        </CCol>
        <CCol
          v-if="
            currentUserLevel === ROLE.AGENT_SUB ||
              currentUserLevel === ROLE.AGENT_ADMIN
          "
          sm="8"
        >
          <BaseInput
            v-if="item.as === 'input'"
            v-show="item.key === 'privacy_policy_URL' && editable"
            v-model="item.value"
            :rules="editable && item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            plaintext
          />
          <BaseTextarea
            v-if="item.as === 'area' && item.key === 'welcome_message'"
            v-model="item.value"
            :name="item.name"
            :vee-name="item.name"
            plaintext
          />
          <BaseTextarea
            v-if="item.as === 'area' && item.key === 'exit_message'"
            v-model="item.value"
            :rules="item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            :plaintext="!editable"
          />
          <div class="form-group">
            <CLink
              v-show="item.key === 'privacy_policy_URL' && !editable"
              :href="item.value"
              target="_blank"
            >
              {{ item.value }}
            </CLink>
          </div>
        </CCol>
        <CCol
          v-if="
            currentUserLevel === ROLE.AGENT_AUDIT ||
              currentUserLevel === ROLE.AGENT_ANNOUNCE
          "
          sm="8"
        >
          <BaseInput
            v-if="item.as === 'input'"
            v-show="item.key === 'privacy_policy_URL' && editable"
            v-model="item.value"
            :rules="editable && item.rules"
            :name="item.name"
            :vee-name="item.name"
            :type="item.type"
            plaintext
          />
          <BaseTextarea
            v-if="item.as === 'area'"
            v-model="item.value"
            :name="item.name"
            :vee-name="item.name"
            plaintext
          />

          <div class="form-group">
            <CLink
              v-show="item.key === 'privacy_policy_URL' && !editable"
              :href="item.value"
              target="_blank"
            >
              {{ item.value }}
            </CLink>
          </div>
        </CCol>
      </CRow>
    </BaseCardDetail>
  </div>
</template>
